import { render, staticRenderFns } from "./goodd.vue?vue&type=template&id=30b9827e&scoped=true&"
import script from "./goodd.vue?vue&type=script&lang=js&"
export * from "./goodd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b9827e",
  null
  
)

export default component.exports